// Generated from scripts/email-signup.ts. Rebuild with pnpm scripts:build.
import { focusFormResult, readFormState } from '@theme/form-result';
/**
 * The return trip of an email signup. The post reloads the page, Shopify comes back at the fragment of the form that
 * was posted, and the block prints the result in place (blocks/email-signup.liquid). A browser that finds an element
 * for that fragment skips every `autofocus` of the page and clears a focus set before the fragment was applied, so the
 * block cannot rely on the attribute: this element moves focus through the shared owner (scripts/form-result.ts),
 * to the thanks note after a success and to the email field after an error that names it. A result that belongs to
 * another form of the page is left alone.
 *
 * A signup inside a popup is the popup's: it opens again with the result and focuses it (scripts/popup.ts), so this
 * element does nothing there. Without the script the form still posts, reloads and shows the result.
 */
class WontioEmailSignup extends HTMLElement {
    connectedCallback() {
        if (this.closest('wontio-popup'))
            return;
        const state = readFormState(this);
        if (state === null)
            return;
        const target = this.querySelector(state === 'success' ? '[data-form-state="success"]' : 'input[aria-invalid="true"]');
        if (target)
            focusFormResult(target);
    }
}
if (!customElements.get('wontio-email-signup')) {
    customElements.define('wontio-email-signup', WontioEmailSignup);
}
